import { useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const ExcluirAviso = () => {
    const { showNotification } = useNotification();
    const { id } = useParams();
    const navigate = useNavigate();

    const [confirm, setConfirm] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await authFetch(`notification/${id}`, {
                method: 'DELETE'
            });

            if (!response.ok) throw new Error('Erro ao excluir aviso');

            showNotification("success", "Aviso excluído com sucesso!");
            navigate('/Avisos');
        } catch (error) {
            console.error(error);
            showNotification("danger", "Erro ao excluir aviso");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Excluir Aviso</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="avisos form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <p>Tem certeza que deseja excluir este aviso?</p>
                                    <div className="mb-3 form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={confirm}
                                            onChange={(e) => setConfirm(e.target.checked)}
                                            required
                                        />
                                        <label className="form-check-label">
                                            Confirmo a exclusão
                                        </label>
                                    </div>
                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <Link to={'/Avisos'} className="btn btn-info btn-sm">Voltar</Link>
                                        <button type="submit" className="btn btn-danger btn-sm mx-1" disabled={!confirm}>
                                            Excluir
                                        </button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExcluirAviso;
